<template>
  <div class="slide-toggle">
    <span class="switchery switchery-small" :class="classNames" @click.prevent="switchMode">
      <small></small>
    </span>
  </div>
</template>

<script type="text/javascript">
  export default {
    name: 'slide-toggle',
    props: ['value', 'stringValues', 'canEdit'],
    data: function() {
      return {
        btnState: this.getOldState()
      }
    },
    methods: {
      switchMode: function() {
        if(this.canEdit) {
          this.btnState = !this.btnState
          this.updateValue()
        }
      },
      getStringValue: function() {
        return this.btnState ? this.stringValues.on : this.stringValues.off
      },
      updateValue: function() {
        this.$emit('input', this.getStringValue())
      },
      getOldState: function() {
        return this.value == this.stringValues.on ? true : false
      }
    },
    watch: {
      value() {
        this.btnState = this.getOldState()
      }
    },
    computed: {
      classNames() {
        let classes = this.btnState ? 'switchery-on' : 'switchery-off'
        if(!this.canEdit) classes += ' disabled'
        return classes
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/SlideToggle.vue